import { useEffect, useRef, useState } from "react";

export const useWasSeen = (elementRef, options, callback) => {
  const [wasSeen, setWasSeen] = useState(typeof IntersectionObserver !== "function");
  const callbackRef = useRef(callback);

  // Keep callback ref updated
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (wasSeen || typeof IntersectionObserver !== "function") return;

    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !wasSeen) {
        setWasSeen(true);
        callbackRef.current();
        observer.disconnect(); // Stop observing after first intersection
      }
    }, options);

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [elementRef, options, wasSeen]); // Correct dependencies

  return wasSeen;
};
